<template>
    <div>

        <trax-ui-form :id="id" :form="form" :action="action" :bus="bus">

            <trax-ui-checkbox v-for="permission in permissions_select" :key="permission.value" 
                :text="permission.name" v-model="form.permissions[permission.value]">
            </trax-ui-checkbox>

        </trax-ui-form>

    </div>
</template>

<script>
    export default {
    
        data: function() {
            return {
                id: 'trax-account-role-edit',
                lang: lang,
                raw_permissions: data.permissions,
                permissions_select: [],
                form: {
                    permissions: {}
                },
                errors: {},
                action: {
                    align: 'right',
                    label: lang.polaris.form.save
                },
                bus: this.$bus
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-data', function(data) {
                that.selectData(data);
            });

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });
        },

        methods: {

            selectData(data) {

                // Prepare the permissions.
                Object.keys(this.raw_permissions).forEach(domain => {
                    let permissions = this.raw_permissions[domain].permissions
                    Object.keys(permissions).forEach(key => {
                        this.form.permissions[key] = false
                        this.permissions_select.push({ value: key, name: permissions[key].name })
                    })
                })

                // Set the permission values.
                if (data.permissions) {
                    for (var index in data.permissions) {
                        this.form.permissions[index] = data.permissions[index];
                    }
                }
            }
        }
    }
</script>
